export default {
  "Audio Compressor": "音频压缩",
  "HitPaw Online Audio Compressor": "压缩音频",
  "Reduce audio file size online without quality loss.": "线上无损压缩音频文件",
  "Compress": "压缩",
  "Compressing": "压缩中",
  "Compressed Successfully": "压缩成功",
  "Compress New": "压缩新文件",
  "Compression is complete": "压缩完成",
  "Compression failed": "压缩失败",
  "Quality": "质量",
  "Format": "格式",
  "Add file": "添加文件",
  "Output Settings": "输出设置",

};
